import React, { createContext, useContext, useState } from "react";

interface Props {
  children: React.ReactNode;
}

export type PersistentDrawerState = {
  drawerWidth: string;
  isPersistentDrawerOpen: boolean;
  handleOpenPersistentDrawer: () => void;
  handleClosePersistentDrawer: () => void;
  handleUpdateDrawerWidth: (width: string) => void;
};

export const PersistentDrawerContext = createContext<PersistentDrawerState>({
  drawerWidth: "600px",
  isPersistentDrawerOpen: false,
  handleOpenPersistentDrawer: () => false,
  handleClosePersistentDrawer: () => false,
  handleUpdateDrawerWidth: (width: string) => false,
});

const PersistentDrawerProvider = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState("600px");
  const handleOpenPersistentDrawer = () => {
    setIsOpen(true);
  };
  const handleClosePersistentDrawer = () => {
    setIsOpen(false);
  };

  const handleUpdateDrawerWidth = (width: string) => {
    setDrawerWidth(width);
  };

  return (
    <PersistentDrawerContext.Provider
      value={{
        isPersistentDrawerOpen: isOpen,
        handleClosePersistentDrawer,
        handleOpenPersistentDrawer,
        handleUpdateDrawerWidth,
        drawerWidth,
      }}
    >
      {children}
    </PersistentDrawerContext.Provider>
  );
};

export default PersistentDrawerProvider;

export const usePersistentDrawer = (): PersistentDrawerState => {
  return useContext(PersistentDrawerContext);
};
